type Props = {
  title: string;
  description: string;
  image?: string;     // explizit pro Card setzen
  href?: string;
  tags?: string[];
}

export default function ProjectCard({
  title,
  description,
  image,
  href = '#',
  tags = [],
}: Props) {
  // neutraler Fallback (nicht ersetzen!)
  const imgSrc = image ?? '/src/assets/placeholder-project.jpg';

  return (
    <a
      href={href}
      className="group block rounded-2xl glass overflow-hidden hover:translate-y-[-2px] transition shadow-[0_10px_30px_rgba(0,0,0,0.25)]"
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={imgSrc}
          alt={title}
          className="h-full w-full object-cover transition group-hover:scale-[1.03]"
        />
      </div>
      <div className="p-5">
        <h3 className="text-lg font-semibold">{title}</h3>
        <p className="mt-2 text-sm text-slate-300">{description}</p>
        <div className="mt-4 flex flex-wrap gap-2">
          {tags.map((t) => (
            <span
              key={t}
              className="rounded-md bg-white/5 px-2 py-1 text-xs text-slate-300 border border-white/10"
            >
              {t}
            </span>
          ))}
        </div>
      </div>
    </a>
  )
}
